import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, Mail, MapPin, Clock, Building2 } from "lucide-react";

const AboutSection = () => {
  return (
    <section
      data-testid="about-section"
      className="section-padding bg-[#FAFAF8]"
    >
      <div className="container mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src="https://images.unsplash.com/photo-1758524053982-dc0fc7cd651f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxoYXBweSUyMGhvbWVvd25lciUyMGNvdXBsZSUyMGluJTIwZ2FyZGVufGVufDB8fHx8MTc3MjcwNjI1NHww&ixlib=rb-4.1.0&q=85"
                alt="Happy homeowners"
                className="w-full h-auto object-cover"
              />
            </div>
            {/* Stats Card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl shadow-xl p-6 hidden md:block">
              <div className="text-center">
                <span className="font-heading text-4xl font-bold text-[#2D5A27]">10+</span>
                <p className="text-[#4B5563] text-sm mt-1">Years Serving LA</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 text-[#C2410C] font-medium text-sm mb-4">
              <Building2 className="w-4 h-4" />
              About Us
            </span>
            <h2
              data-testid="about-headline"
              className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#1A2C22] font-bold mb-6"
            >
              Your Local Landscaping Partner
            </h2>
            <p className="text-[#4B5563] text-base md:text-lg mb-6 leading-relaxed">
              CasaCurate Store has been serving Los Angeles homeowners with professional landscaping and gardening services since 2015. Our dedicated team brings expertise, creativity, and attention to detail to every project.
            </p>
            <p className="text-[#4B5563] text-base md:text-lg mb-8 leading-relaxed">
              We take pride in transforming outdoor spaces into beautiful, functional areas that families can enjoy for years to come. From initial design to ongoing maintenance, we're here to help you achieve your landscaping goals.
            </p>

            {/* Contact Info */}
            <div className="bg-white rounded-2xl p-6 space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <MapPin className="w-5 h-5 text-[#2D5A27] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="font-semibold text-[#1A2C22]">CasaCurate Store</p>
                  <p className="text-[#4B5563] text-sm">
                    1513 Sunset Boulevard, Los Angeles, CA 90027
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <Phone className="w-5 h-5 text-[#2D5A27] flex-shrink-0" />
                <a href="tel:+17711871113" className="text-[#4B5563] hover:text-[#2D5A27] transition-colors">
                  +1-771-1871-113
                </a>
              </div>
              <div className="flex items-center gap-4">
                <Mail className="w-5 h-5 text-[#2D5A27] flex-shrink-0" />
                <a href="mailto:info@casacurate.store" className="text-[#4B5563] hover:text-[#2D5A27] transition-colors">
                  info@casacurate.store
                </a>
              </div>
              <div className="flex items-start gap-4">
                <Clock className="w-5 h-5 text-[#2D5A27] mt-0.5 flex-shrink-0" />
                <div className="text-[#4B5563] text-sm">
                  <p>Mon - Fri: 7:00 AM - 6:00 PM</p>
                  <p>Sat: 8:00 AM - 4:00 PM</p>
                  <p>Sun: Closed</p>
                </div>
              </div>
            </div>

            <Link to="/about">
              <Button
                data-testid="about-learn-more"
                className="bg-[#2D5A27] hover:bg-[#1E3F1B] text-white h-12 px-8 rounded-full cta-primary"
              >
                Learn More About Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
